var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardapioDigital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f09400;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m44.27,15.83h4.71v-4.71h14.13v23.55h-4.71v-14.13h-4.71v4.71h-14.13v-14.13h4.71v4.71Zm0,18.83h-4.71v-4.71h4.71v4.71Zm9.42,0h-4.71v-4.71h4.71v4.71Zm-4.94,14.12h4.71v4.65l-.28.05h-4.42v-4.71Zm-9.42,6.17v-15.59h23.55v11.56c-1.52.53-3.09,1-4.71,1.43v-8.28h-14.13v10.63c-1.56.12-3.13.2-4.71.24Zm31.16-2.21c-.41-.42-1.05-.53-1.58-.28-8.54,4.07-19.7,6.32-31.41,6.32s-22.86-2.24-31.41-6.32c-.53-.25-1.17-.14-1.58.28-.41.42-.52,1.06-.26,1.59,3.88,7.86,17.55,13.35,33.25,13.35s29.37-5.49,33.25-13.35c.26-.53.16-1.17-.26-1.58Zm-44.76-3.96h-4.71v4.65l.28.05h4.42v-4.71Zm9.42,6.17v-15.59H11.6v11.56c1.52.53,3.09,1,4.71,1.43v-8.28h14.13v10.63c1.56.12,3.13.2,4.71.24Zm-18.84-25.01h4.71v4.71h14.13V11.12h-4.71v14.13h-4.71v-4.71h-14.13v14.13h4.71v-4.71Zm0-18.83h-4.71v4.71h4.71v-4.71Zm9.42,0h-4.71v4.71h4.71v-4.71ZM8.57,0h57.86c4.71,0,8.57,3.86,8.57,8.57v57.86c0,4.71-3.86,8.57-8.57,8.57H8.57c-4.71,0-8.57-3.86-8.57-8.57V8.57C0,3.86,3.86,0,8.57,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardapioDigital);
export default __webpack_public_path__ + "static/media/CardapioDigital.e349787d8100b33171bb6675b1caa1e0.svg";
export { ForwardRef as ReactComponent };